import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { Button, Input, InputGroup, InputGroupText} from 'reactstrap';
import * as yup from 'yup';
import styles from './Ats.module.scss';
import ModalDialog from '../../components/common/Modal/Modal';
import useModal from '../../components/Hooks/useModal';
import PositionForm from '../../components/Position/AddPositionForm';
import Form from '../../components/common/Form/From';
import { AiOutlinePlus } from 'react-icons/ai';
import DataTable from 'react-data-table-component';
import tableCustomStyles from '../../components/common/CustomeStyle';
import { jobProfileService } from '../../services';
import { Search } from 'react-bootstrap-icons';
import { CiFilter } from 'react-icons/ci';
import { BsExclamation } from 'react-icons/bs';
import Popover from '../../components/common/Popover/Popover';
import ActionMenu from '../../components/common/ActionMenu/ActionMenu';
import ProfileFilter from '../../components/ProfileFilter/ProfileFilter';
import { jobProfileActions } from '../../actions';
import { formatMoney, isEmptyObject, updateURLParameter } from '../../helpers';
import ConfirmDialog from '../../components/common/ConfirmDialog/ConfirmDialog';
import sortIcon from '../../resources/images/sort.svg';
import Loader from '../../components/common/Loader/Loader';
import ExtendOpningRow from '../../components/ExtendRow/ExtendOpningRow';
import NoDataFond from '../../components/common/noDatafound/noDataPage';
import moment from 'moment';
import ReferalModal from '../../components/common/Modal/ReferalModal';
import DescriptionModal from '../../components/common/Modal/DescriptionModal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


function AtsPage() {
  const { toggle: addPositionToggle, visible: positionVisible } = useModal();
  const { toggle: addDescriptionToggle, visible: descriptionVisible } = useModal();
  const { toggle: addPositionToggleTwo, visible: positionVisibleTwo } =
    useModal();
  let { toggle: ConfirmToggle, visible: ConfirmModal } = useModal();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const [searchParams] = useSearchParams();
  const [pending, setPending] = useState(true);
  const [profileData, setProfileData] = useState({});
  const [filterText, setFilterText] = useState('');
  const [page, setPage] = useState(1);
  const [submited, setSubmited] = useState(false);
  const [btnUpdate, setBtnUpdate] = useState('');
  const [channelPopover, setChannelPopover] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [sort, setSort] = useState('id');
  const [sortType, setSortType] = useState('desc');
  const [filterData, setFilterData] = useState(null);
  const [isFilter, setIsFilter] = useState(false);
  const countPerPage = 10;
  const [jobTitle, setJobTitle] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [jobProfileName, setJobProfileName] = useState('');
  const [jobId, setJobId] = useState('');
  const [initialValues, setInitialValues] = useState({
    jobTitle: '',
    jobProfile: '',
    noOfProfiles: '',
    experienceYear: '',
    experienceMonth: '',
    currType: 'INR',
    // descriptionFile: "",
    dueDate: '',
    budgetFrom: '',
    budgetTo: '',
    priority: 'Medium',
    jobStatus: '',
    assigneeId: '',
    jobType: 'external',
    location: '',
    positionType: 'Full Time',
    description: '',
  });

  useEffect(() => {
    if(user && user.userRole !== 4){
      dispatch(jobProfileActions.getAuthSearch());
    }
  }, []);

  const [columns, setColumns] = useState([]);

  const SUPPORTED_FORMATS = ['application/pdf', 'application/msword'];
  const positionSchema = yup.object().shape({
    jobProfile: yup.string().required('Job Profile is required'),
    jobTitle: yup.string().required('Job Title is required'),
    description: yup.string().required('Description is required'),
    location: yup.string().required('Location is required'),
    noOfProfiles: yup.number().required('No. of Openings is required'),
  });
  const updateSchema = yup.object().shape({
    jobProfile: yup.string().required('Job Profile is required'),
    jobTitle: yup.string().required('Job Title is required'),
    description: yup
      .string()
      .required('Description is required')
      .test({
        name: 'equalTo',
        exclusive: false,
        message: 'Description is required',
        test: function (value) {
          return value !== '<p><br></p>';
        },
      }),
    location: yup.string().required('Location is required'),
    noOfProfiles: yup.number().required('No. of Openings is required'),
  });
  const atsData = useSelector((state) => state.jobProfiles.jobProfile);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.authentication.user);



  useEffect(() => {
    const infoTooltip = (
      <Tooltip id="info-tooltip">Job Description</Tooltip>
    );

    if (user && user?.userRole === 4) {
      setColumns([
        {
          cell: (row) => <span></span>,
          allowOverflow: true,
          width: '20px',
        },
        {
          name: 'Title',
          selector: (row) => {
            return (
              <>
              <div className={styles.titleWrapper}>
                <OverlayTrigger
                  placement="right"
                  overlay={infoTooltip}
                >
                  <p className={styles.infoIcon} type='button'
                    onClick={() => {
                      setJobDescription(row?.description);
                      addDescriptionToggle();
                    }}
                  >i</p>
                </OverlayTrigger>
                <p className={styles.title}>{row?.jobTitle}</p>
              </div>
              </>
            )  
          },
          sortable: true,
          sortField: 'jobTitle',
          grow: 2,
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Profile',
          selector: (row) => row?.job_profile?.name,
          sortable: true,
          sortField: 'jobProfile',
          grow: 2,
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'No. of Openings',
          selector: (row) => row?.noOfProfiles,
          sortable: true,
          sortField: 'noOfProfiles',
          grow: 2,
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Experience',
          selector: (row) =>
            row?.experienceYear + ' Y ' + (row?.experienceMonth + ' M'),
          sortable: true,
          sortField: 'experience',
          grow: 2,
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Location',
          selector: (row) => row?.location,
          sortable: true,
          sortField: 'location',
          grow: 2,
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Position Type',
          selector: (row) => row?.positionType,
          sortable: true,
          sortField: 'positionType',
          grow: 2,
          style: {
            cursor: 'default',
          },
        },
        {
          cell: (row) => (
            <div className={styles.buttonPart}>
              <Button
                type='button'
                onClick={() => {
                  setJobId(row.id);
                  setJobTitle(row.jobTitle);
                  setJobProfileName(row.job_profile.name);
                  addPositionToggleTwo();
                }}
                className={styles.brandButton}
              >
                Refer
              </Button>
            </div>
          ),
          allowOverflow: true,
          width: '100px',
        },
      ]);
    } else {
      setColumns([
        {
          name: 'Title',
          selector: (row) => {
            return (
              <>
                <div className={styles.titleWrapper}>
                  <OverlayTrigger
                    placement="right"
                    overlay={infoTooltip}
                  >
                    <p className={styles.infoIcon} type='button'
                      onClick={() => {
                        setJobDescription(row?.description);
                        addDescriptionToggle();
                      }}
                    >i</p>
                  </OverlayTrigger>
                  { row?.jobStatus === 'Drafted' ?
                    <p style={{ marginBottom: '0px' }}>{row?.jobTitle}</p> :
                    <Link
                      className={`header-link ${styles.title}`}
                      to={`/applicants/${row.id}?profileId=${row.jobProfile}&jobId=${row.id}&location=${row.location}&tab=applications`}
                      state={{ jobTitle: row.jobTitle, jobStatus: row.jobStatus }}
                    >
                      {row?.jobTitle}
                    </Link>
                  }
                </div>
              </>
            )
          },
          sortable: true,
          sortField: 'jobTitle',
          grow: 2,
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Profile',
          selector: (row) => row?.job_profile?.name,
          sortable: true,
          sortField: 'jobProfile',
          grow: 2,
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Status',
          selector: (row) => row.jobStatus,
          sortable: true,
          sortField: 'jobStatus',
          style: {
            cursor: 'default',
          },
        },
        // {
        //   name: "Cluster",
        //   selector: (row) => row?.cluster?.name,
        //   sortable: true,
        //   sortField: "clusterId",
        //   style: {
        //     cursor: "default",
        //   },
        // },
        // {
        //   name: "Openings",
        //   selector: (row) => row?.noOfProfiles,
        //   sortable: true,
        //   sortField: "noOfProfiles",
        //   grow: 1,
        //   style: {
        //     cursor: "default",
        //   },
        // },
        // {
        //   name: "Experience",
        //   selector: (row) => ((row?.experienceYear +
        //     " Y ") +
        //     (row?.experienceMonth +
        //       " M")),
        //   sortable: true,
        //   sortField: "experience",
        //   grow: 2,
        //   style: {
        //     cursor: "default",
        //   },
        // },
        {
          name: 'Budget Range',
          selector: (row) => (
            <div className='budgetColumn'>
              {formatMoney(row.budgetFrom) == 0 &&
              formatMoney(row.budgetTo) == 0
                ? '  '
                : formatMoney(row.budgetFrom) +
                  ' - ' +
                  formatMoney(row.budgetTo)}
            </div>
          ),
          sortable: true,
          sortField: 'budgetFrom',
          grow: 1.5,
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Due Date',
          selector: (row) =>
            row.dueDate ? moment(row.dueDate).format('DD/MM/YYYY') : '',
          sortable: true,
          sortField: 'dueDate',
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Priority',
          selector: (row) => row.priority,
          sortable: true,
          sortField: 'priority',
          style: {
            cursor: 'default',
          },
        },
        {
          name: 'Assignee',
          selector: (row) => (
            <div className='header-link'>
              <span title={row?.assigneeNames}>{row?.assigneeNames}</span>
            </div>
          ),
          sortable: true,
          sortField: 'assigneeNames',
          style: {
            cursor: 'default',
          },
        },
        {
          cell: (row) => (
            <ActionMenu
              size='small'
              type='openings'
              row={row}
              setEditedData={setEditedData}
              setDeleteId={setDeleteId}
              setJobId={setJobId}
              setJobTitle={setJobTitle}
              setJobProfileName={setJobProfileName}
              addPositionToggleTwo={addPositionToggleTwo}
            />
          ),
          allowOverflow: true,
          width: '56px',
        },
      ]);
    }
  }, [user]);

  const getRequestParams = (
    filterText,
    page,
    pageSize,
    sort,
    sortType,
    filterData
  ) => {
    let params = {};
    if (searchParams.get('jobProfile')) {
      params['jobProfile'] = searchParams.get('jobProfile');
    }

    if (location?.state && location?.state?.jobId) {
      params['jobId'] = location?.state?.jobId;
    }

    if (filterText) {
      params['search'] = filterText;
    }

    if (page) {
      params['page'] = page;
    }

    if (pageSize) {
      params['page_size'] = pageSize;
    }

    if (sort) {
      params['sort'] = sort;
    }

    if (sortType) {
      params['sort_type'] = sortType;
    }

    if (!isEmptyObject(filterData)) {
      params = { ...params, ...filterData };
    }

    return params;
  };

  const getProfileData = async () => {
    let query = await getRequestParams(
      filterText,
      page,
      countPerPage,
      sort,
      sortType,
      filterData || { jobStatus: ['Drafted', 'Active'] }
    );
    if (filterData === null) {
      setFilterData({ jobStatus: ['Drafted', 'Active'] });
      setIsFilter(true);
    }
    setPending(true);
    jobProfileService
      .getAllProfiles(query)
      .then((res) => {
        if (query !== undefined) {
          window.history.replaceState(
            '',
            '',
            updateURLParameter(window.location.href, new URLSearchParams(query))
          );
        }
        setProfileData(res);
        setPending(false);
      })
      .catch((e) => {
        setProfileData({});
        setPending(false);
      });
  };

  const handleSort = async (column, sortDirection) => {
    if (column?.sortField) {
      setSort(column?.sortField);
      setSortType(sortDirection);
    }
  };

  useEffect(() => {
    if(user && user.userRole !== 4){
      dispatch(jobProfileActions.getAssignee());
    }
  }, []);

  useEffect(() => {
    if (positionVisible) {
      dispatch(jobProfileActions.getMasterData('designation'));
      // dispatch(jobProfileActions.getCluster());
      dispatch(jobProfileActions.getCities('india'));
    } else {
      resetVal();
    }
  }, [positionVisible]);

  useEffect(() => {
    if (filterData === null) {
      getProfileData();
      // setFilterData({jobStatus:['Drafted', 'Active']})
    }
  }, []);

  useEffect(() => {
    getProfileData();
  }, [page, sort, sortType, filterData, filterText, location]);

  useEffect(() => {
    if (atsData?.results && atsData.results.length > 0) {
      setProfileData(atsData.results);
    }
  }, [atsData]);

  useEffect(() => {
    if (editedData !== null && editedData.id) {
      setInitialValues({
        jobTitle: editedData?.jobTitle,
        jobProfile: editedData?.jobProfile,
        noOfProfiles: editedData?.noOfProfiles,
        experienceYear: editedData?.experienceYear,
        experienceMonth: editedData?.experienceMonth,
        currType: editedData?.currType ? editedData?.currType : 'INR',
        // descriptionFile: "",
        dueDate: editedData?.dueDate,
        budgetFrom: editedData?.budgetFrom ? editedData?.budgetFrom : '',
        budgetTo: editedData?.budgetTo ? editedData?.budgetTo : '',
        priority: editedData?.priority,
        jobStatus: editedData?.jobStatus,
        assigneeId: editedData?.assigneeId ? editedData?.assigneeId : '',
        jobType: editedData?.jobType,
        location: editedData?.location,
        positionType: editedData?.positionType,
        description: editedData?.description,
      });
      addPositionToggle();
    }
  }, [editedData]);

  useEffect(() => {
    if (deleteId !== null) {
      ConfirmToggle();
    }
  }, [deleteId]);

  const handleSubmit = (values) => {
    setSubmited(true);
    if (values) {
      if (editedData !== null && editedData?.id) {
        dispatch(
          jobProfileActions.updateJobProfile(values, editedData?.id)
        ).then((res) => {
          if (res) {
            setSubmited(false);
            resetVal();
            getProfileData();
            addPositionToggle();
          }
          setSubmited(false);
          setBtnUpdate('');
        });
      } else {
        dispatch(jobProfileActions.createProfile(values)).then((res) => {
          if (res) {
            setSubmited(false);
            resetVal();
            getProfileData();
            addPositionToggle();
          }
          setSubmited(false);
        });
      }
    }
  };

  const resetVal = () => {
    setInitialValues({
      jobTitle: '',
      jobProfile: '',
      noOfProfiles: '',
      experienceYear: '',
      experienceMonth: '',
      // descriptionFile: "",
      dueDate: '',
      currType: 'INR',
      budgetFrom: '',
      budgetTo: '',
      priority: 'Medium',
      jobStatus: '',
      assigneeId: '',
      jobType: 'external',
      location: '',
      positionType: 'Full Time',
      description: '',
    });
    setEditedData(null);
    setDeleteId(null);
  };

  const renderForm = (errors, touched) => {
    return (
      <PositionForm
        errors={errors}
        touched={touched}
        submited={submited}
        editedData={editedData}
        btnUpdate={btnUpdate}
        setBtnUpdate={setBtnUpdate}
      />
    );
  };

  const deleteProfile = (id) => {
    if (id) {
      dispatch(jobProfileActions.deleteJobProfile(id));
      resetVal();
      ConfirmToggle();
      setTimeout(() => {
        getProfileData();
      }, 600);
    }
  };

  const hangleFilterOption = (data) => {
    if (!isEmptyObject(data)) {
      setFilterData(data);
      setIsFilter(true);
      setPage(1);
    } else {
      setPage(1);
      setFilterData(null);
      setIsFilter(false);
    }
  };

  const searchChange = (e) => {
    setFilterText(e?.target?.value);
    setPage(1);
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className='main-header-buttons'>
        <div className={styles.buttonPart}>
          {/* {user && user?.userRole !== 4 && ( */}
            <div className='d-flex gap-2'>
              {user && user?.userRole !== 4 && (
                <Button
                  type='button'
                  onClick={() => addPositionToggle()}
                  className={styles.brandButton}
                >
                  <AiOutlinePlus /> Add Opening
                </Button>
              )}

              <Button
                type='button'
                onClick={() => {
                  setJobId();
                  setJobTitle();
                  setJobProfileName();
                  addPositionToggleTwo()
                }}
                className={styles.brandButton}
              >Refer For Upcoming Openings
              </Button>
            </div>
          {/* )} */}
        </div>
        <div>
          <InputGroup className='my-2 my-md-0'>
            <InputGroupText className='search-addon'>
              <Search />{' '}
            </InputGroupText>
            <Input
              className='search-input'
              placeholder='Search'
              value={filterText}
              onChange={(e) => {
                searchChange(e);
              }}
            />
            <Button
              disabled={user && user?.userRole === 4 }
              type='button'
              className={`btn ${isFilter ? 'filter-btn-active' : 'filter-btn'}`}
              id='filter-button'
            >
              <CiFilter />
              Filter
            </Button>
          </InputGroup>
        </div>
      </div>
    );
  }, [filterText, isFilter]);

  return (
    <div className={styles.atsMain}>
      <div className='mt-3'>
        {profileData?.data_present ? (
          <>
            <DataTable
              columns={columns}
              data={profileData?.results}
              customStyles={tableCustomStyles}
              highlightOnHover
              pointerOnHover
              striped
              pagination
              paginationServer
              paginationTotalRows={profileData?.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              progressPending={pending}
              progressComponent={
                <Loader
                  height={50}
                  width={50}
                  color={'#5382ba'}
                  center={true}
                />
              }
              onChangePage={(page) => setPage(page)}
              onSort={handleSort}
              sortServer
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
              persistTableHead
              responsive
              sortIcon={<img src={sortIcon} alt='sort' />}
              expandableRows={user && user?.userRole === 4 ? false : true}
              expandableRowExpanded={(row) => row.defaultExpanded}
              expandableRowsComponent={ExtendOpningRow}
            />
            <Popover
              popoverOpen={channelPopover}
              target='filter-button'
              handleToggle={() => {
                setChannelPopover(!channelPopover);
              }}
              title={''}
              pbody={
                <ProfileFilter
                  hangleFilterOption={hangleFilterOption}
                  setChannelPopover={setChannelPopover}
                  filterData={filterData}
                />
              }
              classname='report-popover'
              placement='bottom-end'
            />
          </>
        ) : (
          <>
            <div className='main-header-buttons'>
              <div className={styles.buttonPart}>
                {user && user?.userRole !== 4 && (
                  <Button
                    type='button'
                    onClick={() => addPositionToggle()}
                    className={styles.brandButton}
                  >
                    <AiOutlinePlus /> Add Opening
                  </Button>
                )}
              </div>
              <div>
                <InputGroup className='my-2 my-md-0'>
                  <Button
                    type='button'
                    className={`btn ${'filter-btn-active'}`}
                    id='filter-button'
                  >
                    <CiFilter />
                    Filter
                  </Button>
                </InputGroup>
                <Popover
                  popoverOpen={channelPopover}
                  target='filter-button'
                  handleToggle={() => {
                    setChannelPopover(!channelPopover);
                  }}
                  title={''}
                  pbody={
                    <ProfileFilter
                      hangleFilterOption={hangleFilterOption}
                      setChannelPopover={setChannelPopover}
                      filterData={filterData}
                    />
                  }
                  classname='report-popover'
                  placement='bottom-end'
                />
              </div>
            </div>
            {profileData?.data_present === false ? (
              <NoDataFond />
            ) : (
              <Loader color={'#5382ba'} />
            )}
          </>
        )}
      </div>
      <ModalDialog
        toggle={addPositionToggle}
        title={`${editedData !== null ? 'Update' : 'Add'} Opening`}
        visible={positionVisible}
        size='lg'
        bodyClass='p-0'
      >
        <Form
          initialValues={initialValues}
          validationSchema={editedData !== null ? updateSchema : positionSchema}
          handleSubmit={handleSubmit}
          renderForm={renderForm}
        />
      </ModalDialog>
      <ReferalModal
        toggle={addPositionToggleTwo}
        visible={positionVisibleTwo}
        size='lg'
        bodyClass='p-0'
        jobTitle={jobTitle}
        jobProfileName={jobProfileName}
        jobId={jobId}
      ></ReferalModal>

      <DescriptionModal
        toggle={addDescriptionToggle}
        visible={descriptionVisible}
        jobDescription={jobDescription}
        size='lg'
        bodyClass='p-0'
      >
      </DescriptionModal>
      <ConfirmDialog
        visible={ConfirmModal}
        toggle={ConfirmToggle}
        title='Are you sure you want to delete the Profile?'
        activeBtnClick={() => {
          deleteProfile(deleteId);
        }}
      >
        <div className={`confirmIcon rounded-circle`}>
          <BsExclamation style={{ fontSize: 42 }} />
        </div>
      </ConfirmDialog>
    </div>
  );
}

export default AtsPage;
